module.exports = "<p-button icon=\"fa fa-search\" label=\"{{ 'LAYOUT:BUTTON:SEARCH_SIGN' | translate }}\" (onClick)=\"showSearchSign()\"></p-button>\r\n"